import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from '../../assets/images/white-logo.png';

function Header() {
  return (
    <Navbar expand="lg">
    <Container>
      <Navbar.Brand href="#home"><img src={Logo} alt="Logo"/></Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto">
          <Nav.Link href="#home">Search Talent</Nav.Link>
          <Nav.Link href="#link">Faq</Nav.Link>
          <Nav.Link href="#link">Login/Signup</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
  )
}

export default Header